<template>
  <div v-if="show" class="vx-col md:w-1/3 lg:w-1/3 xl:w-1/3 mr-5">
    <label class="vs-input--label">Territory</label>
    <v-select v-model="selected" :options="options" placeholder="All" />
  </div>
</template>
<script>
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect
  },
  props: {
    territoryAreaId: {
      type: Number
    },
    parentPersonalId: {
      type: Number
    }
  },
  data() {
    return {
      selected: null,
      options: [],
      mutableTerritoryAreaId: null,
      mutableParentPersonalId: null
    };
  },
  methods: {
    getData() {
      this.$http
        .get("/api/v1/dashboard/territory-list", {
          params: {
            territory_area_id: this.mutableTerritoryAreaId,
            parent_personal_id: this.mutableParentPersonalId
          }
        })
        .then(resp => {
          if (resp.status == "success") {
            var options = [];
            resp.data.forEach(function(item) {
              options.push({
                label: item.label,
                personalId: item.personal_id,
                territoryId: item.territory_id
              });
            }, options);
            this.options = options;
          } else {
            this.$vs.loading.close();
          }
        });
    }
  },
  mounted() {
    this.mutableTerritoryAreaId = this.$userLogin.territory_area_id;
    // this.mutableParentPersonalId = this.$userLogin.id;
    this.getData();
  },
  computed: {
    show() {
      let show = false;
      if (this.$userLogin.roles) {
        this.$userLogin.roles.filter(function(item) {
          switch (item.Name) {
            case "superadmin":
              show = true;
              break;
            case "admin":
              show = true;
              break;
            case "fulfillment":
              show = true;
              break;
            case "sales_area_director":
              show = true;
              break;
          }
        }, show);
      }
      return show;
    }
  },
  watch: {
    selected: function(val) {
      if (val) {
        this.$emit("managerPersonalId", val.personalId);
        this.$emit("territoryId", val.territoryId);
      } else {
        this.$emit("managerPersonalId", null);
        this.$emit("territoryId", null);
      }
    },
    territoryAreaId(val) {
      this.mutableTerritoryAreaId = val;
      this.getData();
    },
    parentPersonalId(val) {
      this.mutableParentPersonalId = val;
      this.getData();
    },
    mutableTerritoryAreaId() {
      this.getData();
    },
    mutableParentPersonalId() {
      this.getData();
    }
  }
};
</script>